import { Box, Typography, Stack, Divider, Card, CardContent, CircularProgress } from "@mui/material";
import Slide from '@mui/material/Slide';
import DoneIcon from '@mui/icons-material/Done';
import { getSecondsToText, getDateStringToTimeText } from 'utils/commonFunc';

export const EmergencyVehicleInfoBox = (props) => {
    const {
        //serviceId, 
        serviceName,
        departureTime,
        estimatedTime, // sec
        fireStationName,
        startName,
        endName,
        remainRouteRatio,
        arrivalTime,
    } = props;

    return (
        <Box sx={{ minWidth: '600px', overflow: 'hidden' }}>
            <Slide timeout={1000} in={true} easing={{ enter: "ease-out", exit: "ease-in" }} direction="up">
                <Card variant='outlined' sx={{p:0.5}}>
                    <CardContent>
                        <Stack direction="row" alignItems="center" spacing={2}>
                            {arrivalTime ? <DoneIcon sx={{ color: 'lime', transform: 'scale(2.0)' }} /> : <CircularProgress size={26} thickness={6} />}
                            <Typography variant="h4" >
                                {`${serviceName}${fireStationName && ` (${fireStationName})`}`}
                            </Typography>
                        </Stack>
                        <Divider sx={{ mb: 1, mt: 1 }} />
                        <Stack direction="row" justifyContent="space-between" color={'#eeeeee'}>
                            <Typography variant="h5">
                                {startName}
                            </Typography>
                            <Typography variant="h5">
                                {endName}
                            </Typography>
                        </Stack>
                        {/* color={estimatedSec === 0 ? "success" : "rgb(255, 30, 30)"}  */}
                        {/* <BorderLinearProgress variant="determinate"
                            value={
                                arrivalTime ? 100 : 
                                (remainRouteRatio ? 100 - Math.floor(remainRouteRatio * 100) : 0 )
                                } /> */}
                        
                        <Box sx={{ height: '30px', width: '100%', bgcolor:(arrivalTime ? 'lime' : 'rgba(100,100,100,0.9)'), animation: 'blink 1.0s ease-in-out infinite alternate' }}>
                            <Box sx={{ height: '100%', width: `${remainRouteRatio * 100}%`, float:'right' }} bgcolor={'rgb(255, 30, 30)'}>
                                {/* <Typography variant="h6" align='left' sx={{ minWidth: '100px' }}>{'>'}</Typography> */}
                                {/* <MinorCrashIcon sx={{ml:'-12px'}}/> */}
                                <img src="/images/icons8-car-94.png" alt="" style={{height:'100%', marginLeft:'-13px'}}/>
                            </Box>
                        </Box>
                        <Stack direction="row" justifyContent="space-between" color={'#eeeeee'}>
                            <Typography variant="h4">
                                {`${getDateStringToTimeText(departureTime)} 발생`}
                            </Typography>
                            <Typography variant="h4">
                                {arrivalTime ? '도착' : estimatedTime ? remainRouteRatio ? `${getSecondsToText(estimatedTime * remainRouteRatio)} 남음` : '예측 시간 없음' : '예측 시간 없음'}
                            </Typography>
                        </Stack>
                    </CardContent>
                </Card>
            </Slide>
        </Box>

    )
}